import api from "api/api";

export const createAppeal = async (data) =>
  await api.post("/settings/appeal", data);

export const deleteAppealById = async (id) =>
  await api.delete(`/settings/appeal/${id}`);

export const getAppealById = async (id) =>
  await api.get(`/settings/appeal/${id}`);

export const getAppealList = async () => await api.get("/settings/appeal");

export const updateAppealById = async (id, data) =>
  await api.put(`/settings/appeal/${id}`, data);
